






































































































































































import Vue from 'vue';
import { AxiosResponse } from 'axios';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, Dialog } from '@kasasa/fbase-components/lib';
import { ConfigVersion } from '@/api/configversion/';
import HolidayDialog from '@/components/HolidayDialog.vue';
import {
  Holiday,
  HolidayResource,
  ProcessingDays,
  ProcessingDaysResource,
} from '@/api/processingdays';

@Component({
  computed: mapState(['fiId']),
  components: {
    'holiday-dialog': HolidayDialog,
  },
})
export default class ProcessingDaysAndHolidays extends Vue {
  @Inject('HolidayResource')
  holidayResource!: HolidayResource;

  @Inject('ProcessingDaysResource')
  processingDaysResource!: ProcessingDaysResource;

  fiId!: number;

  processingDays: ProcessingDays | null = null;

  normalProcessingDays = new Array<boolean>(7).fill(false);

  workingNormalProcessingDays = new Array<boolean>(7).fill(false);

  workingAlwaysProcessFirstDayOfMonth: boolean = false;

  workingAlwaysProcessLastDayOfMonth: boolean = false;

  isProcessingDaysModified: boolean = false;

  weekday = new Array(7);

  loading: boolean = false;

  cancelling: boolean = false;

  saving: boolean = false;


  holidays: Holiday[] = [];

  holidayHeaders:DataTableHeader[] = [
    { text: '', value: 'warning', sortable: false },
    { text: '', value: 'edit', sortable: false },
    { text: 'Date', value: 'holidayDate', sortable: false },
    { text: 'Day', value: 'day', sortable: false },
    { text: 'Holiday Name', value: 'name', sortable: false },
  ];

  footerProps = {
    'items-per-page-options': [{ value: -1, text: 'All' }, 25, 50, 100],
  }


  @Watch('configVersion')
  mounted() {
    this.loading = true;

    this.weekday[0] = 'Sunday';
    this.weekday[1] = 'Monday';
    this.weekday[2] = 'Tuesday';
    this.weekday[3] = 'Wednesday';
    this.weekday[4] = 'Thursday';
    this.weekday[5] = 'Friday';
    this.weekday[6] = 'Saturday';

    this.processingDaysResource.getAll(this.fiId)
      .then((result:ProcessingDays) => {
        this.processingDays = result;
        this.initializeWorkingProcessingDays();
        this.loadHolidays();
      })
      .catch((error:any) => {
        this.showError(error);
        this.loading = false;
      });
  }

  initializeWorkingProcessingDays() {
    this.normalProcessingDays = new Array<boolean>(7).fill(false);
    this.workingNormalProcessingDays = new Array<boolean>(7).fill(false);
    this.processingDays!.normalProcessingDays.forEach((day) => {
      this.normalProcessingDays[day % 7] = true; // serverValue for Sunday is 7
      this.workingNormalProcessingDays[day % 7] = true;
    });

    this.workingAlwaysProcessFirstDayOfMonth = this.processingDays!.alwaysProcessFirstDayOfMonth;
    this.workingAlwaysProcessLastDayOfMonth = this.processingDays!.alwaysProcessLastDayOfMonth;
    this.isProcessingDaysModified = false;
  }

  saveProcessingDays() {
    if (this.numberOfProcessingDays() < 5) {
      this.setError('Must select at least five Core Processing Days!');
      return;
    }
    this.saving = true;
    this.processingDaysResource.update(this.fiId, this.getWorkingProcessingDays())
      .then((savedProcessingDays:ProcessingDays) => {
        this.processingDays = savedProcessingDays;
        this.initializeWorkingProcessingDays();
        this.saving = false;
      })
      .catch((error:any) => {
        this.saving = false;
        this.showError(error);
      });
  }

  numberOfProcessingDays() {
    let count = 0;
    for (let i:number = 0; i < this.workingNormalProcessingDays.length; i++) {
      if (this.workingNormalProcessingDays[i]) {
        count++;
      }
    }
    return count;
  }

  getWorkingProcessingDays():ProcessingDays {
    const updatedNormalProcessingDays = [];
    for (let i:number = 1; i < this.workingNormalProcessingDays.length; i++) {
      if (this.workingNormalProcessingDays[i]) {
        updatedNormalProcessingDays.push(i);
      }
    }
    if (this.workingNormalProcessingDays[0]) {
      updatedNormalProcessingDays.push(7); // serverValue for Sunday is 7
    }

    return {
      normalProcessingDays: updatedNormalProcessingDays,
      alwaysProcessFirstDayOfMonth: this.workingAlwaysProcessFirstDayOfMonth,
      alwaysProcessLastDayOfMonth: this.workingAlwaysProcessLastDayOfMonth,
    };
  }

  isDataModified() {
    this.isProcessingDaysModified = (this.processingDays!.alwaysProcessFirstDayOfMonth
            !== this.workingAlwaysProcessFirstDayOfMonth)
      || (this.processingDays!.alwaysProcessLastDayOfMonth
            !== this.workingAlwaysProcessLastDayOfMonth)
      || this.isNormalProcessingDaysUpdated();

    this.getWorkingProcessingDays();
  }

  isNormalProcessingDaysUpdated():boolean {
    for (let i:number = 0; i < this.normalProcessingDays.length; i++) {
      if (this.normalProcessingDays[i] !== this.workingNormalProcessingDays[i]) {
        return true;
      }
    }
    return false;
  }

  loadHolidays() {
    this.holidays = [];
    this.holidayResource.getAll(this.fiId)
      .then((result: Holiday[]) => {
        this.holidays = result;
        this.sortHolidays(this.holidays!);
        this.loading = false;
      })
      .catch((error:any) => {
        this.showError(error);
        this.loading = false;
      });
  }

  sortHolidays = (holidays: Holiday[]) => holidays.sort((a, b) => {
    if (new Date(a.holidayDate).valueOf() < new Date(b.holidayDate).valueOf()) {
      return -1;
    }
    if (new Date(a.holidayDate).valueOf() > new Date(b.holidayDate).valueOf()) {
      return 1;
    }
    throw new Error('Server returned Holidays collection with'
        + ' unexpected holidayDate unique constraint violation!');
  })

  onHolidaySaved(savedHoliday: Holiday) {
    let found:boolean = false;
    for (let i:number = 0; i < this.holidays.length; i++) {
      if (this.holidays[i].id === savedHoliday.id) {
        // Saved an existing holiday, so make sure that it is up to date.
        Object.assign(this.holidays[i], savedHoliday);
        found = true;
        break;
      }
    }
    if (!found) {
      const holiday = savedHoliday;
      this.holidays.push(holiday);
    }
    this.sortHolidays(this.holidays!);
  }

  onDeleteHoliday(holiday: Holiday) {
    const that = this;
    const dialog = new Dialog('Confirm Deletion',
      'Are you sure you want to delete this holiday?');
    dialog.setAcceptLabel('OK')
      .setDeclineLabel('Cancel');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          that.holidayResource.remove(that.fiId, holiday.id as number)
            .then((result:AxiosResponse) => {
              that.removeHolidayFromList(holiday);
            });
        }
      });
  }

  removeHolidayFromList(holiday: Holiday) {
    for (let i:number = 0; i < this.holidays.length; i++) {
      if (this.holidays[i].id === holiday.id) {
        this.holidays.splice(i, 1);
        break;
      }
    }
  }

  getDay(date: string) {
    const parts = date.split('-');
    return this.weekday[this.parseDate(date).getDay()];
  }

  getFriendlyFormattedDate = (date: string) => {
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  }

  parseDate = (date: string) => {
    const parts = date.split('-');
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }

  firstOrLastDayofMonth(date: string) {
    if (this.processingDays!.alwaysProcessFirstDayOfMonth && this.isFirstDayOfMonth(date)) {
      return 'First';
    }
    if (this.processingDays!.alwaysProcessLastDayOfMonth && this.isLastDayOfMonth(date)) {
      return 'Last';
    }
    return '';
  }

  isLastDayOfMonth(date: string) {
    const currentDate = this.parseDate(date);
    const curMonth = currentDate.getMonth();

    currentDate.setDate(currentDate.getDate() + 1);
    const monthNextDay = currentDate.getMonth();

    return curMonth !== monthNextDay;
  }

  isFirstDayOfMonth(date: string) {
    const currentDate = this.parseDate(date);
    const curMonth = currentDate.getMonth();

    currentDate.setDate(currentDate.getDate() - 1);
    const monthPrevDay = currentDate.getMonth();

    return curMonth !== monthPrevDay;
  }

  showError(error: any) {
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
